<template>
    <!-- 步骤条组件 -->
    <el-steps 
    :active="value"
    :space="space"  
    :align-center="isCenter"
    :direction="direction"
    :simple="isSimple"
    :process-status="procesSstatus"
    :finish-status="finishStatus"
    >
        <template v-for="(step,sinx) in stepList">
            <el-step 
            :title="step.title" 
            :icon="step.icon"
            :key="step.title + sinx"
            :description="step.des"
            :status="step.status"
            />
        </template>
    </el-steps>
</template>
<script>
export default {
    name:"VelSteps",
    props:{
        initValue:Number,
        space:[Number,String],
        direction:String,
        finishStatus:{
            type:String,
            default:'success'
        },
        procesSstatus:String,
        isCenter:Boolean,
        isSimple:Boolean,
        stepList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            value:0,
            center:false,
            simple:false,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true,
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isCenter ? this.center = true : this.center
            this.isSimple ? this.simple = true : this.simple
        },
        getValue(){
            this.value = this.initValue
        }
    }
}
</script>